import { useDispatch } from "react-redux";
import { useLazyGetTermsQuery } from "../../../Store/Builder/techsbook.api";
import showToast from "../../Hooks/toast";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import { useState } from "react";

const useTerms = () => {
  const dispatch = useDispatch();
  const [getTerms] = useLazyGetTermsQuery();

  const [terms, setTerms] = useState([]);

  const get = () => {
    dispatch(setLoader(true));
    getTerms()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        setTerms(res);
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
    terms,
  };
};

export default useTerms;
